export default "__VITE_ASSET__D6LGrF89__"